const CHUNK_LOAD_ERROR_PATTERNS = [
  "dynamically imported module",
  "failed to fetch dynamically imported module",
  "importing a module script failed",
  "loading chunk",
];

function getStringField(value: unknown, fieldName: string): string | undefined {
  if (typeof value !== "object" || value === null) {
    return undefined;
  }

  const fieldValue = Reflect.get(value, fieldName);
  return typeof fieldValue === "string" ? fieldValue : undefined;
}

function normalizeErrorText(value: string | undefined): string {
  return value?.toLowerCase() ?? "";
}

export function isChunkLoadError(error: unknown): boolean {
  const errorName = normalizeErrorText(getStringField(error, "name"));
  const errorMessage = normalizeErrorText(getStringField(error, "message"));

  if (errorName === "chunkloaderror") {
    return true;
  }

  return CHUNK_LOAD_ERROR_PATTERNS.some((pattern) => errorMessage.includes(pattern));
}
